// Derives the right-rail status cards (no-metadata/waiting counters).
import { useMemo } from 'react';
import { format } from 'date-fns';
import {
  getTaskProjects,
  getTaskContexts,
} from '@/features/tasks/utils/data/taskTags';
import {
  isSchedulableTask,
  getCapacityDurationMinutes,
} from '@/features/tasks/utils/scheduling/taskSchedulingUtils';

export function usePlanRailStats(allTasks, tasksMap = new Map()) {
  const todayStr = format(new Date(), 'yyyy-MM-dd');

  const plannedMinutesToday = useMemo(() => {
    const schedulableToday = (allTasks || []).filter(
      (task) => task.date === todayStr && isSchedulableTask(task, tasksMap),
    );
    return schedulableToday.reduce(
      (sum, task) =>
        sum + getCapacityDurationMinutes(task, schedulableToday, tasksMap),
      0,
    );
  }, [allTasks, tasksMap, todayStr]);

  const tasksWithoutMetadata = useMemo(
    () =>
      (allTasks || []).filter(
        (task) =>
          getTaskProjects(task).length === 0 &&
          getTaskContexts(task).length === 0,
      ),
    [allTasks],
  );

  const waitingTasks = useMemo(
    () => (allTasks || []).filter((task) => Boolean(task.person)),
    [allTasks],
  );

  return { plannedMinutesToday, tasksWithoutMetadata, waitingTasks };
}
